import {PlantationService} from "plantation/service";

import {useAuth} from "base/user/provider";
import {useCreateEntity} from "base/entity/hooks";
import {usePlantationsTable} from "plantation/data";

import {EntityListPage} from "base/entity/components/container";
import {PlantationFilterForm} from "plantation/presentational/form";
import {CreatePlantationForm} from "plantation/container";

const ListPlantationsPage = () => {
    const {tableColumns, getCellProps} = usePlantationsTable();
    const auth = useAuth();

    let {
        button: createButton,
        dialog: createDialog,
        handleClickClose: closeDialog,
    } = useCreateEntity(
        null,
        "Novo plantio",
        <CreatePlantationForm onCancel={() => closeDialog()} />
    );

    if (!auth.hasPermission("create-plantations")) {
        createDialog = null;
        createButton = null;
    }

    return (
        <>
            {createDialog}
            <EntityListPage
                views={["table, map"]}
                entityName={{
                    singular: "Plantio",
                    plural: "Plantios",
                }}
                service={PlantationService}
                tableColumns={tableColumns}
                getCellProps={getCellProps}
                filterForm={<PlantationFilterForm />}
                createButton={createButton}
                disableNavigation
                enableExport={true}
            />
        </>
    );
};
export default ListPlantationsPage;
